/**
 * @fileoverview Model for a synced field setting.
 *
 * @author Stephanie Yoon (steyoon@yext.com)
 */

import {OverrideFieldKey, OverrideFieldKeyJson} from '/src/com/yext/listingslaunchstorm/js/enterprise/setuppublisher/data/overridefieldkey';
import {SyncedFieldKey, SyncedFieldKeyJson} from '/src/com/yext/listingslaunchstorm/js/enterprise/setuppublisher/data/syncedfieldkey';

export class SyncedFieldSetting {
  /**
   * @param {{
   *  syncedFieldKey: SyncedFieldKey,
   *  overrideFieldKey: (OverrideFieldKey | undefined),
   *  enabled: boolean,
   *  replaceExisting: boolean,
   *  applyToNewSubAccounts: boolean,
   * }} params
   */
  constructor(params) {
    /** @type {SyncedFieldKey} */
    this.syncedFieldKey = params.syncedFieldKey;
    /** @type {OverrideFieldKey | undefined} */
    this.overrideFieldKey = params.overrideFieldKey;
    /** @type {boolean} */
    this.enabled = params.enabled;
    /** @type {boolean} */
    this.replaceExisting = params.replaceExisting;
    /** @type {boolean} */
    this.applyToNewSubAccounts = params.applyToNewSubAccounts;
  }

  /**
   * @return {!SyncedFieldSettingJson}
   */
  toJSON() {
    return {
      'syncedFieldKey': this.syncedFieldKey.toJSON(),
      'overrideFieldKey': this.overrideFieldKey?.toJSON(),
      'enabled': this.enabled,
      'replaceExisting': this.replaceExisting,
      'applyToNewSubAccounts': this.applyToNewSubAccounts,
    };
  }

  /**
   * @param {!SyncedFieldSettingJson} json
   * @return {!SyncedFieldSetting}
   */
  static fromJSON(json) {
    return new SyncedFieldSetting({
      syncedFieldKey: SyncedFieldKey.fromJSON(json['syncedFieldKey']),
      overrideFieldKey: json['overrideFieldKey'] == undefined ? undefined : OverrideFieldKey.fromJSON(json['overrideFieldKey']),
      enabled: json['enabled'],
      replaceExisting: json['replaceExisting'],
      applyToNewSubAccounts: json['applyToNewSubAccounts'],
    });
  }
}

/**
 * @dict
 * @typedef {{
 *  syncedFieldKey: SyncedFieldKeyJson,
 *  overrideFieldKey: (OverrideFieldKeyJson | undefined),
 *  enabled: boolean,
 *  replaceExisting: boolean,
 *  applyToNewSubAccounts: boolean,
 * }}
 */
export let SyncedFieldSettingJson;
